/**
 * Utils for numbers. Used for a better parsing of numbers than native JS.
 */

var VRC = VRC || {};
VRC.Utils = VRC.Utils || {};
VRC.Utils.Number = (function(){

	var stringStartsWith = function(string, prefix) {
		if(typeof string !== 'string'){ return false;}
		return string.slice(0, prefix.length) == prefix;
	};

	var filterFloat = function (value) {
		if(typeof value === 'string'){
			value = value.replace(/,/g, '.');
		}

		if(/^(\-|\+)?([0-9]+(\.[0-9]+)?|Infinity)$/
				.test(value))
			return Number(value);
		return NaN;
	};

	/**
	 * Name _parseFloat because parseInt is a global function and keeps it consistent.
	 * To avoid NaN and support , and .
	 * ParseNum https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/parseFloat
	 * @param $object form element or inputelements.
	 */
	var _parseFloat = function(orgNumber){
		if(orgNumber === undefined || orgNumber === null){
			return undefined;
		}
		try {
			if(stringStartsWith(orgNumber, '.') || stringStartsWith(orgNumber, ',')){
				orgNumber =  '0' + orgNumber;
			}
			var number = filterFloat(orgNumber);
			if(isNaN(number)){
				throw orgNumber + ' is Nan (' + arguments.callee.caller.toString();
			}
			return number;
		}
		catch(e){

			return undefined;
		}
	};

	/**
	 * Name _parseInt because parseInt is a global function.
	 * To avoid NaN
	 * ParseNum https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/parseInt
	 * @param $object form element or inputelements.
	 */
	var _parseInt = function(orgNumber){
		if(orgNumber === undefined || orgNumber === null){
			return undefined;
		}
		try {
			var number = parseInt(orgNumber);
			if(isNaN(number)){
				throw orgNumber + ' is Nan' + arguments.callee.caller.toString();
			}
			return number;
		}
		catch(e){

			return undefined;
		}
	};

	return {
		parseInt : _parseInt,
		parseFloat : _parseFloat
	}
})();